import * as ValidateModel from '../shared/ValidateModel';
import Garment from "../objects/garments/garment";
import Garments from "../objects/garments/garments";

const fields = {
    ID_GARMENT : 'idGarment',
    ID_PRODUCT : 'idProduct',
    NAME : 'name',
    DESCRIPTION_SHORT : 'descriptionShort',
    DESCRIPTION : 'description',
    LINK : 'link',
    IMAGE: 'image',
    PRICE : 'price',
    PRICE_TAX_EXCL : 'priceTaxExcl',
    PRICE_LOW : 'priceLow',
    PRICE_LOW_PERCENTAGE : 'priceLowPercentage',
    PRICE_LOW_AMOUNT : 'priceLowAmount',
    GARMENT_PART_COUNT : 'garmentPartCount',
    SAME_GARMENT_PART_COUNT : 'sameGarmentPartCount',
};

class GarmentsConverter {
    static convertOne = (data: any): Garment => {
        ValidateModel.isObject(data, 'data');
        const {
            [fields.ID_GARMENT] : idGarment,
            [fields.ID_PRODUCT] : idProduct,
            [fields.NAME] : name,
            [fields.DESCRIPTION_SHORT] : descriptionShort,
            [fields.DESCRIPTION]: description,
            [fields.LINK] : link,
            [fields.IMAGE] : image,
            [fields.PRICE] : price,
            [fields.PRICE_TAX_EXCL] : priceTaxExcl,
            [fields.PRICE_LOW] : priceLow,
            [fields.PRICE_LOW_PERCENTAGE] : priceLowPercentage,
            [fields.PRICE_LOW_AMOUNT] : priceLowAmount,
            [fields.GARMENT_PART_COUNT] : garmentPartCount,
            [fields.SAME_GARMENT_PART_COUNT] : sameGarmentPartCount,
        } = data;

        return new Garment(
            idGarment,
            idProduct,
            name,
            descriptionShort,
            description,
            link,
            image,
            price,
            priceTaxExcl,
            priceLow,
            priceLowPercentage,
            priceLowAmount,
            garmentPartCount,
            sameGarmentPartCount,
        );
    };

    static convertAllToArray = (data: any[]): Garment[] => {
        ValidateModel.isArray(data, 'data');
        return data.map((item) => GarmentsConverter.convertOne(item));
    };

    static convertAll = (data: any[]): Garments => {
        ValidateModel.isArray(data, 'data');
        return new Garments(GarmentsConverter.convertAllToArray(data));
    }
}

export default GarmentsConverter;
